import {
    INIT_MENU,
    INIT_MENU_SUCCESS,
    CHANGE_ACTIVE_MENU_FROM_LOCATION,
    CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS,
    TOGGLE_MENU_ITEM,
    SET_ACTIVE_MENU_ITEM,
    CLEAR_MENU,
} from './constants';

const initialState = {
    menuItems: [],
    activatedMenuItemIds: [],
    expandedItems: [],
    activeMenuItem: null,
};

const AppMenu = (state = initialState, action) => {
    switch (action.type) {
        case INIT_MENU:
            return { ...state };
        case INIT_MENU_SUCCESS:
            return { ...state, ...action.payload };
        case CHANGE_ACTIVE_MENU_FROM_LOCATION:
            return { ...state };
        case CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS:
            return { ...state, ...action.payload };
        case TOGGLE_MENU_ITEM:
            const { itemId } = action.payload;
            const expandedItems = state.expandedItems.includes(itemId)
                ? state.expandedItems.filter(id => id !== itemId)
                : [...state.expandedItems, itemId];
            return { ...state, expandedItems };
        case SET_ACTIVE_MENU_ITEM:
            return { 
                ...state, 
                activeMenuItem: action.payload.itemId,
                activatedMenuItemIds: [action.payload.itemId] // Only set the clicked item as active
            };
        case CLEAR_MENU:
            return { ...initialState };
        default:
            return state;
    }
};

export default AppMenu;
